// removed by extract-text-webpack-plugin
module.exports = {"container":"_2hMaY","medium":"vElw5","large":"_2vkIW","search":"_3xSXG"};


//////////////////
// WEBPACK FOOTER
// ./app/components/content-excerpt/content-excerpt.scss
// module id = 985
// module chunks = 0 3 4 5 6